/**
 * Default color palette expressed in row form.
 * * * * */

export default {
	data: function() {
		return {
			colors: [
				{ // red
					red: 255,
					green: 34,
					blue: 11
				},
				{ // orange
					red: 255,
					green: 135,
					blue: 4
				},
				{ // yellow
					red: 255,
					green: 193,
					blue: 0
				},
				{ // green
					red: 53,
					green: 197,
					blue: 0
				},
				{ // blue
					red: 23,
					green: 51,
					blue: 237
				},
				{ // purple
					red: 173,
					green: 35,
					blue: 255
				}
			]
		}
	}
}
